<template>
    <div>
        <v-card :elevation="0" class="v-sheet theme--light br-0">
            <v-card-title>
                <v-row class="col-md-12">
                    <v-col cols="12" sm="12" md="12">
                        Exportar Diccionario de Respuestas
                    </v-col>
                    
            
                </v-row>
                 <v-row class="col-md-12 pt-0 pb-0 mb-0">
                    <v-col cols="12" md="5" sm="5" xs="12" class="pt-0 pb-0 mb-0">
                        <v-select
                            v-model="datosItem.periodoMedicionId"
                            :items="periodos"
                            :loading="ddPeriodosLoading"
                            dense
                            outlined
                            label="Periodo de medición"
                            item-text="anioMedicion"
                            item-value="id"
                            :no-data-text="periodos!=null ? 'Selecciona un periodo' : 'No se han encontrado periodos'"
                            @change="establecido=false;"
                        ></v-select>
                    </v-col>

                    <v-col cols="12" md="7" sm="7" xs="12" class="pt-0 pb-0 mb-0">
                        <v-select
                            v-model="indiceSeleccionadoId"
                            :items="indices"
                            :loading="ddIndicesLoading"
                            :disabled="datosItem.periodoMedicionId<=0"
                            dense
                            outlined
                            label="Seleccionar Índice"
                            item-text="nombreIndice"
                            item-value="id"
                            :hint="datosItem.periodoMedicionId<=0 ? 'Debe seleccionar un periodo de medición' : ''"
                            :no-data-text="indices ? 'Selecciona un índice' : 'No se han registrado índices'"
                            @change="obtenerBoletasPorIndice(); establecido=false;"
                        ></v-select>
                    </v-col>
                </v-row>

                <v-row class="col-md-12 pt-0 mt-0">
                    <v-col cols="12" md="5" sm="5" xs="12" class="pt-0 mt-0 pb-1">
                        <v-select
                            v-model="datosItem.boletasId"
                            :items="boletas"
                            :loading="ddBoletasLoading"
                            dense
                            outlined
                            label="Seleccionar boleta"
                            item-text="descripcion"
                            item-value="id"
                            :no-data-text="indices.length<=0 ? 'No se ha seleccionado un índice' : 'El índice seleccionado no tiene boletas asignadas'"
                            @change="establecido=false;"
                        ></v-select>
                    </v-col>

                     <v-col cols="12" md="7" sm="7" xs="12" class="pt-0 mt-0 pb-1">
                        <v-btn
                            color="primary"
                            class="mb-2 float-right bg-light-blue"
                            @click="obtenerDiccionarioRespuestas();"
                            :disabled="datosItem.boletasId<=0 || indiceSeleccionadoId<=0"
                        >
                            Buscar
                            <v-icon right>mdi-magnify</v-icon>
                        </v-btn>
                    </v-col> 

                    
                </v-row>

                <v-row v-if="establecido==false">
                    <v-col cols="12">
                        <v-alert
                            text
                            prominent
                            type="error"
                            icon="mdi-alert"
                            dense
                            small
                            >
                                <p class="mt-3">Para poder exportar respuestas, debes de establecer la configuración de periodo de medición, índice y boleta.</p> 
                            </v-alert>
                    </v-col>
                </v-row>

                <v-row class="col-md-12 m-0 p-0">
                    <v-divider></v-divider>
                </v-row>
            </v-card-title>

            
                        
            <v-card-text>
                <v-row>
                    <v-col cols="12" sm="4" md="4" xs="12">
                        <download-excel 
                            class="btn btn-md btn-primary bg-light-blue" 
                            :fetch="exportarTabla" 
                            :disabled="true"
                            worksheet="DICCIONARIO_RESPUESTAS"
                        >
                            EXPORTAR
                            <v-icon left>mdi-database-export</v-icon>
                            </download-excel>
                    </v-col> 

                    <v-col cols="12" md="8" sm="8" xs="12">
                        <v-text-field
                            outlined
                            autocomplete="off"
                            dense
                            v-model="tableFilter"
                            label="Buscar"
                            maxlength="100"
                        ></v-text-field>
                    </v-col>
                </v-row>


                <SubHeader subHeaderTitle="Preguntas Asignadas a la boleta " />
                
                
                <v-data-table
                        :headers="headers"
                        :items="diccionarioRespuestas"
                        item-key="Id"
                        class="elevation-0"
                        :loading="tableLoading"
                        no-data-text="No hay datos para mostrar"
                        :search="tableFilter"
                        :items-per-page="10"
                        :footer-props="{
                            showFirstLastPage: true,
                            firstIcon: 'mdi-page-first',
                            lastIcon: 'mdi-page-last',
                            prevIcon: 'mdi-chevron-left',
                            nextIcon: 'mdi-chevron-right',
                            'items-per-page-text':'Registros por página',
                            pageText: '{0}-{1} de {2}' 
                        }"
                        dense
                    >
                    <template v-slot:item="{ item }">
                        <tr>
                            <!--<td>{{ item.id }}</td>-->
                            <td>{{ item.idRespuesta }}</td>
                            <td>{{ item.nombreRespuesta }}</td>
                            <td>{{ item.tipoDato }}</td>
                            <td>{{ item.preguntaId }}</td>
                            <td>{{ item.nombrePregunta }}</td>
                            <td>{{ item.idPreguntaSuperior }}</td>
                            <td>{{ item.nombrePreguntaSuperior }}</td>
                           
                         
                        </tr>
                    </template>

                </v-data-table>
            </v-card-text>
        </v-card>

    <!--Dialog loader -->
    <dialog-loader
        :dialogVisible="dialogLoaderVisible"
        :text="dialogLoaderText"
    ></dialog-loader>
    <!---->

    <!--Inicio:: Snack alert-->
    <SnackAlert ref="snackalert"></SnackAlert>
    <!-- Fin:: Snack alert-->
    </div>
</template>
<script>
import Vue from 'vue';
import moment from "moment";

import validations from "@/core/untils/validations.js";
import SubHeader from "@/view/components/subheader/SubHeader";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { OBTENER_INDICES } from "@/core/services/store/catalogos/indice.module";
import { OBTENER_PERIODOS } from "@/core/services/store/catalogos/periodomedicion.module";
import { OBTENER_BOLETAS } from "@/core/services/store/boletas/boleta.module";
import { OBTENER_DICCIONARIO_RESPUESTAS} from "@/core/services/store/preguntasperiodoboleta/preguntaperiodoboleta.module";

import SnackAlert from '@/view/content/SnackAlert.vue';
import DialogLoader from "@/view/content/DialogLoader";

moment.locale('es');
Vue.filter("formatDate", function(value) {
    if (value) {
        return moment(String(value)).format("DD/MM/YYYY");
    }
});

export default {
    name: "ConfiguracionBoletas",
    components: {
        SnackAlert,
        SubHeader,
        DialogLoader
    },
    data() {
        return {
            tableLoading: false,
            ddPreguntasLoading:false,
            ddBoletasLoading:false,
            ddSubPreguntasLoading:false,
            diccionarioRespuestas:[],
            tableFilter:'',
            validForm:false,
            validForm2: false,
            establecido:false,
            itemName: "Índices",
            dialog: false,
            dialogAsingarSub:false,
            modalTitle: 'Registrar Índice',
            btnRegistroLoading: false,
            btnRegistroSubLoading:false,
            dialogLoaderVisible: false,
            activePicker:null,
            menuFechaApertura: false,
            menuFechaCierre:false,
            fechas: {
                fechaApertura:'',
                fechaCierre: '',
            },
            dialogLoaderText: 'Obteniendo informacion....',
            btnRegistroText: 'Guardar',
            accion: 1,
            indices: [],
            indiceSeleccionadoId:0,
            preguntas: [],
            subpreguntas:[],
            subPreguntasAsignadas:[],
            subPreguntaSeleccionadaId:0,
            preguntasAsignar:[],
            boletas: [],
            ddIndicesLoading: false,
            ddPeriodosLoading: false,
            periodos: [],
            switchItemEstado: true,
            visitaCampoValores: [{id: 'SI', visita: 'Si'}, {id: 'NO', visita: 'No'}],
            datosItem: {
                id: 0,
                preguntasId:0,
                visitaCampo: 'No',
                noOrdenPregunta: "0",
                periodoMedicionId: 0,
                boletasId:0,
                estadosId: 1
            },
            ...validations
        } 
    }, 
    methods: {
        //!Definir la fecha máxima que se puede seleccionar en el datepicker
        maxDate() {
            const date = new Date();
            date.setFullYear(date.getFullYear() + 1);
            return date.toISOString().substr(0, 10);
        },

        //!Definir la fecha minima que se puede seleccionar en el datepicker
        minDate() {
            const date = new Date();
            date.setFullYear(date.getFullYear());
            return date.toISOString().substr(0, 10);
        },


        modalNueva(){
            this.accion =1;
            this.modalTitle='Asignar pregunta a boleta';
            this.btnRegistroText='Guardar';
            this.switchItemEstado=true;
            this.dialog=true;
        },

        resetForm(){
           // this.$refs.form.reset();
            let boletaSeleccionada = this.datosItem.boletasId;
             this.datosItem= {
                id: 0,
                preguntasId: 0,
                boletasId: boletaSeleccionada,
                noOrdenPregunta: "0",
                periodoMedicionId: this.datosItem.periodoMedicionId,
                indicesId: 0,
                estadosId: 1
            };
            this.accion=1;
            this.switchItemEstado = true;
            //console.log(this.switchItemEstado)
        },

        resetFormSub(){
            this.accion=1;

        },

        async obtenerIndices(){
            this.indices=[];
            this.ddIndicesLoading=true;
            await this.$store
            .dispatch(OBTENER_INDICES, 1)
            .then(res => {
                if(res.status===200){
                    this.indices=res.data;
                } else {
                    console.warn(res.message)
                }
                this.ddIndicesLoading=false;
               
            }
            )
            .catch(() => {
                this.ddIndicesLoading=false;
                //console.warn(err)
            });
        },


        //!Obtener boletas por indice seleccionado y periodo
        async obtenerBoletasPorIndice(){

            this.datosItem.boletasId=0;
            this.boletas=[];
            this.ddBoletasLoading=true;
            await this.$store
            .dispatch(OBTENER_BOLETAS, {idPeriodo: this.datosItem.periodoMedicionId, idIndice: this.indiceSeleccionadoId})
            .then(res => {
                if(res.status===200){
                    this.boletas=res.data;
                } else {
                    console.warn(res.message)
                }
                this.ddBoletasLoading=false;
               
            }
            )
            .catch(() => {
                this.ddBoletasLoading=false;
                //console.warn(err)
            });
        },


        //!Obtener los periodos para la tabla
        obtnenerPeriodosMedicion(){
            this.ddPeriodosLoading = true;
            this.periodos=[];
            
            this.$store
                .dispatch(OBTENER_PERIODOS)
                .then(() => {
                    this.periodos = this.$store.state.periodomedicion.periodos;
                    this.ddPeriodosLoading =false;
                })
                .catch(() => {
                    this.ddPeriodosLoading = false;
                });

        },

    //!Obtener el diccionario de respuestas por periodo y boleta
    async obtenerDiccionarioRespuestas(){
         this.establecido=true;
          this.tableLoading=true;
          this.diccionarioRespuestas=[];
            await this.$store
            .dispatch(OBTENER_DICCIONARIO_RESPUESTAS, {boletaId:this.datosItem.boletasId, periodoId: this.datosItem.periodoMedicionId})
            .then(res => {
                //console.log(res)
                if(res.status===200){
                    this.diccionarioRespuestas = res.data;
                } else {
                    //console.warn(res.message)
                    this.tableNoDataText = 'No se encontraron preguntas para el índice seleccionado';
                }
                this.tableLoading=false;
            })
            .catch(() => {
                this.tableLoading=false;
                this.tableNoDataText = 'No se encontraron preguntas para el índice seleccionado';
                });
        
    },


    exportarTabla(){
        
        
        if(this.diccionarioRespuestas.length<=0){
             this.$refs.snackalert.SnackbarShow('warning', 'Mensaje', "No se han encontrado respuestas para exportar!");
            
        } else {
        this.dialogLoaderText= "Exportando respuestas...";
        this.dialogLoaderVisible=true;
        let datosExportacion = this.diccionarioRespuestas.map(item => {
            return {
                "Id Respuesta": item.idRespuesta,
                "Nombre Respuesta": item.nombreRespuesta,
                "Tipo de Dato": item.tipoDato,
                "Id Pregunta": item.preguntaId,
                "Nombre Pregunta": item.nombrePregunta,
                "Id Pregunta Superior": item.idPreguntaSuperior,
                "Nombre Pregunta Superior": item.nombrePreguntaSuperior
            };
        });

        //console.log(datosExportacion);
        this.dialogLoaderVisible=false;
        return datosExportacion;
        }
    },


  


      

     
  
    },
    mounted() {
        //Definir el nombre en el breadcrumb
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Administración", route: "/dashboard" },
            { title: "Respuestas" },
            { title: "Exportación" }
        ]);
    },

    created(){
        this.obtenerIndices();
       // this.obtnenerItems();
        this.obtnenerPeriodosMedicion();
    },

    
    computed: {
        headers() {
            return [
                /*{
                    text: "Id",
                    align: "start",
                    sortable: true,
                    value: "id"
                },*/
                 {
                    text: "Id Respuesta",
                    align: "start",
                    sortable: false,
                    value: "idRespuesta"
                },
                {
                    text: "Nombre respuesta",
                    value: "nombreRespuesta"
                },
                {
                    text: "Tipo de dato de la respuesta",
                    value: "tipoDato"
                },
                {
                    text: "Id Pregunta",
                    value: "preguntaId"
                },
                {
                    text: "Nombre de la pregunta",
                    value: "nombrePregunta"
                },
                {
                    text: "Id Pregunta Superior",
                    value: "idPreguntaSuperior"
                },
                {
                    text: "Nombre Pregunta Superior",
                    value: "nombrePreguntaSuperior"
                }
            ]
        },

        //Cambiar el formato de fechas a DD-MM-YYY para mostrar y a YYYY-MM-DD para registrar en datosItem.fechaApertura
        fechaApertura:{
            get: function(){
                return this.fechas.fechaApertura
                ? moment(this.fechas.fechaApertura).format("DD-MM-YYYY")
                : null;
            },
            set: function(val){
                
                this.datosItem.fechaApertura = moment(val, 'DD-MM-YYYY').format('YYYY-MM-DD');
                return val;
            }
        },   
        
        //Cambiar el formato de fechas a DD-MM-YYY para mostrar y a YYYY-MM-DD para registrar en datosItem.fechaCierre
        fechaCierre:{
            get: function(){
                return this.fechas.fechaCierre
                ? moment(this.fechas.fechaCierre).format("DD-MM-YYYY")
                : null;
            },
            set: function(val){
                
                this.datosItem.fechaCierre = moment(val, 'DD-MM-YYYY').format('YYYY-MM-DD');
                return val;
            }
        },   
    },

    watch: {
        
        //Cambiar el formato de fecha de apertura/cierre del objeto datosItem al momento de que fechas.fechaApertura/fechas.fechaCierre cambie
        'fechas.fechaApertura': function(val){
            this.datosItem.fechaApertura = val;
        },

        'fechas.fechaCierre': function(val){
            this.datosItem.fechaCierre = val;
        },

    
    }

    
}
</script>
<style lang="">
    
</style>